import * as api from '@owl-nest/api-client/next'

export async function listForUser(
  userId: number,
  getParams?: URLSearchParams,
): Promise<api.HttpResult<api.Pageable<api.OrderList<true>>>> {
  const response = await api.client('GET /users/:id/orders', {
    urlParams: { id: String(userId) },
    getParams,
  })

  return response.next((success) => success.body as api.Pageable<api.OrderList<true>>)
}

export async function markAsDelivered(orderId: number): Promise<api.HttpResult<api.Order<true>>> {
  const response = await api.client('POST /orders/:id/mark-as-delivered', {
    urlParams: { id: String(orderId) },
  })

  return response.next((success) => success.body)
}

export async function markAsUndelivered(orderId: number): Promise<api.HttpResult<api.Order<true>>> {
  const response = await api.client('POST /orders/:id/mark-as-undelivered', {
    urlParams: { id: String(orderId) },
  })

  return response.next((success) => success.body)
}

export async function get(orderId: number): Promise<api.HttpResult<api.Order<true>>> {
  const response = await api.client('GET /orders/:id', {
    urlParams: { id: String(orderId) },
  })

  return response.next((success) => success.body)
}

type ListForProjectConfig = {
  getParams?: URLSearchParams
  withToken?: boolean
}

export async function listForProject<EXTRA_FIELDS extends string>(
  projectId: number | string,
  config: ListForProjectConfig = {},
): Promise<api.HttpResult<api.WithOrderFacets<api.Pageable<api.OrderList<false, EXTRA_FIELDS>>>>> {
  const response = await api.client('GET /projects/:id/orders', {
    urlParams: { id: String(projectId) },
    getParams: config.getParams,
    withToken: config.withToken,
  })

  return response.next(
    (success) => success.body as api.WithOrderFacets<api.Pageable<api.OrderList<false, EXTRA_FIELDS>>>,
  )
}

export async function listForSubscription(
  subscriptionId: number,
  getParams?: URLSearchParams,
): Promise<api.HttpResult<api.Pageable<api.OrderList>>> {
  const response = await api.client('GET /subscriptions/:id/orders', {
    urlParams: { id: String(subscriptionId) },
    getParams,
  })

  return response.next((success) => success.body)
}

// TODO: replace the any in api.Order<any> with correct type given what the api
// is expected to return
export async function update<EXTRA_FIELDS extends string>(
  orderId: number,
  payload: api.UpdateOrder,
): Promise<api.HttpResult<api.Order<any, EXTRA_FIELDS>>> {
  const response = await api.client('PATCH /orders/:id', {
    urlParams: { id: String(orderId) },
    body: payload,
  })

  return response.next((success) => success.body as api.Order<any, EXTRA_FIELDS>)
}

// TODO: replace the any in api.Order<any> with correct type given what the api
// is expected to return
export async function cancel(orderId: number): Promise<api.HttpResult<api.Order<any>>> {
  const response = await api.client('POST /orders/:id/cancel', {
    urlParams: { id: String(orderId) },
  })

  return response.next((success) => success.body)
}

export async function renew(orderId: number, order: Partial<api.Order>): Promise<api.HttpResult<api.Order<false, ''>>> {
  const response = await api.client('POST /orders/:id/renew', {
    urlParams: { id: String(orderId) },
    body: order,
  })

  return response.next((success) => success.body)
}
